import React,{ useState, useEffect } from 'react';

import MailIconButton from "../../components/IconButtons/MailIconButton";
import { useStateContext } from '../../contexts/ContextProvider';
import {getAutorizar} from "../../services/Asignaciones";
import {formatDate} from '../../formatters/date';
//import {updateAsignacion} from '../../services/Asignaciones';

import DataTable from 'react-data-table-component';
import { NuevaAsignacion, AutorizarAsignacion } from '../../components';
import SeleccionaFecha from '../../components/DatePicker/SeleccionaFecha';
import { FolderIcon, UserIcon } from '@heroicons/react/24/solid';

const Autorizar = () => {
  const { handleClick, isClicked } = useStateContext();
  const [archivosData, setArchivosData] = useState([]);
  const [laSucursal, setLaSucursal] = useState("");
  const [laLinea, setLaLinea] = useState("");
  const [autorizarData, setAutorizarData] = useState([]);
  const [selectedDate, setSelectedDate] = useState(getFirstDayOfMonth('Inicio')); // Fecha inicial
  const [selectedDateEnd, setSelectedDateEnd] = useState(getFirstDayOfMonth('Fin')); // Fecha inicial
  const [estado, setEstado] = useState('Pendiente');
  const [numeroSolicitud, setNumeroSolicitud] = useState('');
  const [centroCosto, setCentroCosto] = useState('');

 function getFirstDayOfMonth(Como) {
    const today = new Date();
    const firstDay = new Date(today.getFullYear(), (today.getMonth()) -3 , 1);
    if(Como === 'Inicio') return firstDay;
    if (Como === 'Fin') {
      // Crea una nueva fecha con la hora 23:59:59
      const endOfDay = new Date(today);
      endOfDay.setHours(23, 59, 59, 999); // 23:59:59.999
      return endOfDay;
    }
    if(Como === 'Nada') return null;
  };

  const handleDateChange = (date) => {
    setSelectedDate(date);
  };

  const handleDateChangeEnd = (date) => {
    setSelectedDateEnd(date);
  };

  const handleChangeEstado = (e) =>{
    setEstado( e.target.value );
  }

  useEffect(() => {
    const fetchData = async () => {
      const docuData = await getAutorizar(selectedDate,selectedDateEnd,estado, numeroSolicitud, centroCosto);
      setArchivosData(docuData);
      const dataTemp = await procesarDatosParaTabla(docuData);
      setAutorizarData(dataTemp);
    };
    fetchData();
  },[]);

  useEffect(() => {
    const fetchData = async () => {
      const docuData = await getAutorizar(selectedDate,selectedDateEnd,estado, numeroSolicitud, centroCosto);
      setArchivosData(docuData);
      const dataTemp = await procesarDatosParaTabla(docuData);
      setAutorizarData(dataTemp);
    };
    fetchData();
  },[selectedDate,selectedDateEnd,estado, numeroSolicitud, centroCosto]);

  const procesarDatosParaTabla = async (data) => {
    let rows = [];
  
    data.forEach((solicitud) => {
      solicitud.detalleEquipos.forEach((equipo) => {
        if (estado === 'ALL'){
           if (equipo.selectedEquipo === 0 && equipo.estadoEquipo === 'Pendiente' ) {

           } else {
            if (equipo.selectedEquipo === 1){  
            rows.push({
              maquina: equipo.maquina || "N/A",
              nombreMaquina: equipo.nombreMaquina || "N/A",
              lin: equipo.lin || "N/A",
              fechaEnObra: equipo.fechaEnObra || "N/A",
              codigoCentro: solicitud.codigoCentro || "N/A",
              nombreProyecto: solicitud.nombreProyecto || "N/A",
              solicitante: solicitud.solicitante || "N/A",
              numeroSolicitud: solicitud.numeroSolicitud || "N/A",
              idSolicitud: solicitud.idSolicitud || "N/A",
              _id: solicitud._id || "N/A",
              estadoEquipo: equipo.estadoEquipo,
            });  
            }
          }
        }
        if (estado === 'Pendiente'){
          if (equipo.selectedEquipo === 1 && equipo.estadoEquipo === 'Pendiente' ) { //   Filtrar solo los equipos seleccionados
            rows.push({
              maquina: equipo.maquina || "N/A",
              nombreMaquina: equipo.nombreMaquina || "N/A",
              lin: equipo.lin || "N/A",
              fechaEnObra: equipo.fechaEnObra || "N/A",
              codigoCentro: solicitud.codigoCentro || "N/A",
              nombreProyecto: solicitud.nombreProyecto || "N/A",
              solicitante: solicitud.solicitante || "N/A",
              numeroSolicitud: solicitud.numeroSolicitud || "N/A",
              idSolicitud: solicitud.idSolicitud || "N/A",
              _id: solicitud._id || "N/A",
              estadoEquipo: equipo.estadoEquipo,
            });
          }
        }
        if (estado === 'Aprobado'){
          if (equipo.selectedEquipo === 1 && equipo.estadoEquipo === 'Aprobado' ) { //   Filtrar solo los equipos seleccionados
            rows.push({
              maquina: equipo.maquina || "N/A",
              nombreMaquina: equipo.nombreMaquina || "N/A",
              lin: equipo.lin || "N/A",
              fechaEnObra: equipo.fechaEnObra || "N/A",
              codigoCentro: solicitud.codigoCentro || "N/A",
              nombreProyecto: solicitud.nombreProyecto || "N/A",
              solicitante: solicitud.solicitante || "N/A",
              numeroSolicitud: solicitud.numeroSolicitud || "N/A",
              idSolicitud: solicitud.idSolicitud || "N/A",
              _id: solicitud._id || "N/A",
              estadoEquipo: equipo.estadoEquipo,
            });
          }
        }


      });
    });
  
    return rows;
  };

/*
  const handleEdit = (sucursalData) => {
  // Buscar en la lista archivosData por sucursalData._id
    const sucursal = archivosData.find((sucursal) => sucursal._id === sucursalData._id);
    setLaSucursal(sucursal);
    handleClick('nuevaasignacion');
  };
*/

  const handleAutorizar = async (sucursalData) => {
    // Buscar en la lista archivosData por sucursalData._id
    const sucursal = archivosData.find((sucursal) => sucursal._id === sucursalData._id);
    setLaLinea(sucursalData.lin);
    setLaSucursal(sucursal);
    handleClick('nuevoAutoriza');
  };

  /*
  const handleAprobar = async (row) => {
 
    if (row.estado === 'Pendiente' || row.estado === 'Aprobado' )
    {
      toast.error('Para aprobar el estado debe ser Asignado.');
      return;
    }

    try {
        const upAsigna = {
          _id: row._id,
          idEquipo: row.idEquipo ,
          fechaEntrega: row.fechaEntrega.toISOString() ,
          valorCotizacion: row.valorCotizacion ,
          urlArchivo: row.urlArchivo,
          responsable: row.responsable,
          operador: row.operador,
          comentarios: row.comentarios,
          idAutorizador: row.idAutorizador,
          fechaAutorizacion: row.fechaAutorizacion,
          observacmionAd: row.observacmionAd,
          estado: 'Aprobado'
        };
        await updateAsignacion(upAsigna);
      } catch (error) {
        console.log(error);
        toast.error('Problemas al aprobar asignación, contacte a Soporte.');
        return;
      }
  };
*/
  const handleRefreshDataTable = (opcion) => {
    if (opcion==="REFRESH"){
      setAutorizarData([]);
      const fetchData = async () => {
         const docuData = await getAutorizar(selectedDate, selectedDateEnd, estado, numeroSolicitud, centroCosto);
         setArchivosData(docuData);
         const dataTemp = await procesarDatosParaTabla(docuData);
         setAutorizarData(dataTemp);
       };
       fetchData();
    }
  };

const customStyles = {
  table: {
    style: {
      backgroundColor: 'white',
      borderRadius: '8px',
    },
  },
  head: {
    style: {
      fontSize: '14px',
      fontWeight: 'bold',
      color: '#2F336A',
      backgroundColor: '#F2F5FE',
      borderBottom: '1px solid #D9E1F2',
    },
  },
  headRow: {
    style: {
      minHeight: '48px',
      borderBottomWidth: '1px',
    },
  },
  headCells: {
    style: {
      paddingLeft: '12px',
      paddingRight: '12px',
      whiteSpace: 'nowrap',
    },
  },
  rows: {
    style: {
      fontSize: '13px',
      backgroundColor: 'white',
      minHeight: '52px',
      borderBottom: '1px solid #F3F4F6',
      transition: 'background-color 0.2s ease-in-out',
    },
    highlightOnHoverStyle: {
      backgroundColor: '#F9FAFB',
      borderBottomColor: '#E5E7EB',
      outline: 'none',
    },
  },
  cells: {
    style: {
      paddingLeft: '12px',
      paddingRight: '12px',
    },
  },
};


  const columns = [
    {
      name: '',
      width: '40px',
      cell: (row) => ( <MailIconButton onClick={() => handleAutorizar(row)} /> )
    },
  {
    name: 'Estado',
    width: '120px',
    selector: row => row.estadoEquipo,
    sortable: true,
    cell: (row) => {
      let bgColor = '';
      switch (row.estadoEquipo) {
        case 'Aprobado':
          bgColor = 'bg-green-100 text-green-700';
          break;
        case 'Pendiente':
          bgColor = 'bg-yellow-100 text-yellow-700';
          break;
        default:
          bgColor = 'bg-gray-100 text-gray-700';
      }
      return (
        <div className={`text-xs px-2 py-1 rounded-full text-center ${bgColor}`}>
          {row.estadoEquipo}
        </div>
      );
    }
  },
   
    {
      name: 'Fecha Obra',
      width: '120px',
      selector: row => formatDate(row.fechaEnObra),
      sortable: true
    },
    {
      name: 'C.Costo',
      width: '120px',
      selector: row => row.codigoCentro,
      sortable: true
    },
    {
      name: 'Proyecto',
      width: '300px',
      selector: row => row.nombreProyecto,
      sortable: true,
      cell: (row) => (
      <div className="flex items-center gap-2">
        <FolderIcon className="w-4 h-4 text-blue-500" />
        <span>{row.nombreProyecto}</span>
      </div>
      )
    },
    {
      name: 'Equipo',
      width: '200px',
      selector: row => row.nombreMaquina,
      sortable: true
    },
    {
      name: 'Solicitante',
      width: '250px',
      selector: row => row.solicitante,
      sortable: true,
      cell: (row) => (
      <div className="flex items-center gap-2">
        <UserIcon className="w-4 h-4 text-blue-500" />
        <span>{row.solicitante}</span>
      </div>
        )
    },
    {
      name: 'N° Sol.',
      width: '100px',
      selector: row => row.numeroSolicitud,
      sortable: true
    }
  ];

  return (

<>
<div className="mx-4 lg:mx-12 mt-4">
        <div className="flex justify-between items-center px-4 py-2 border-b border-gray-200 bg-white rounded-t-md shadow-sm">
            <div className="flex items-center gap-2">
              <div className="w-2.5 h-2.5 rounded-full bg-blue-500 animate-pulse" />
              <p className="text-gray-800 font-semibold text-base md:text-lg">
                 Autorizaciones
              </p>
            </div>
        </div>

      <div className="bg-white p-6 rounded-lg shadow-lg mt-2">
        <div className="flex justify-start items-center p-2 md:ml-6 md:mr-6 relative top-1">
          <div className="grid grid-cols-1 md:grid-cols-7 gap-4 w-full">
            
            {/* Fecha Desde */}
            <div className="col-span-2">
              <label className="text-xs font-semibold mb-1 whitespace-nowrap">Desde</label>
              <SeleccionaFecha
                selectedDate={selectedDate}
                handleDateChange={handleDateChange}
              />
            </div>

            {/* Fecha Hasta */}
            <div className="col-span-2">
              <label className="text-xs font-semibold mb-1 whitespace-nowrap">Hasta</label>
              <SeleccionaFecha
                selectedDate={selectedDateEnd}
                handleDateChange={handleDateChangeEnd}
              />
            </div>

            {/* Estado */}
            <div className="col-span-1">
              <label className="text-xs font-semibold mb-1 whitespace-nowrap">Estado Equipo</label>
              <select
                className="text-xs border border-gray-300 p-2 rounded w-full"
                name="estado"
                value={estado}
                onChange={handleChangeEstado}
              >
                <option value="ALL">Todos</option>
                <option value="Pendiente">Pendiente</option>
                <option value="Aprobado">Aprobado</option>
              </select>
            </div>

            {/* N° Solicitud */}
            <div className="col-span-1">
              <label className="text-xs font-semibold mb-1 whitespace-nowrap">N° Solicitud</label>
              <input
                type="text"
                className="text-xs border border-gray-300 p-2 rounded w-full"
                placeholder="Ej: 10234"
                value={numeroSolicitud}
                onChange={(e) => setNumeroSolicitud(e.target.value)}
              />
            </div>

            {/* Centro Costo */}
            <div className="col-span-1">
              <label className="text-xs font-semibold mb-1 whitespace-nowrap">Centro Costo</label>
              <input
                type="text"
                className="text-xs border border-gray-300 p-2 rounded w-full"
                placeholder="Ej: 0451"
                value={centroCosto}
                onChange={(e) => setCentroCosto(e.target.value)}
              />
            </div>


          </div>
        </div>
</div>

    <div className="bg-white p-6 rounded-lg shadow-lg items-end mt-4">
	      <div className="grid grid-cols-1 md:grid-cols-1 gap-4" >
            <div className="flex flex-col">
                <DataTable
                  columns={columns}
                  data={autorizarData}
                  highlightOnHover
                  pagination={true}
                  striped
                  className="border border-gray-300 rounded-lg shadow-sm"
                  noHeader={true}
                  selectableRowsHighlight
                  customStyles={customStyles}
                  noDataComponent={'No hay -equipos asignados- para autorizar'}
                />
            </div>
        </div>
    </div>
      {isClicked.nuevoAutoriza && (<AutorizarAsignacion vecinoData={laSucursal} linea={laLinea} onChangeVecino={handleRefreshDataTable}/>)}
      {isClicked.nuevaasignacion && (<NuevaAsignacion vecinoData={laSucursal} editableData="OFF" onChangeVecino={handleRefreshDataTable}/>)}

</div>

    </>
  );
};

export default Autorizar;